import '../../lightgallery/scss/lightgallery.scss';
import '../../lightgallery/scss/lg-thumbnail.scss';
import '../../lightgallery/scss/lg-autoplay.scss';
import '../../lightgallery/scss/lg-share.scss';

import {LightGallerySettings} from '../../lightgallery/lg-settings';
import {LightGallery} from "../../lightgallery/lightgallery";
import Thumbnail from '../../lightgallery/plugins/thumbnail/lg-thumbnail';
import Autoplay from '../../lightgallery/plugins/autoplay/lg-autoplay';
import Share from '../../lightgallery/plugins/share/lg-share';

export function applyTo(selector: string, options?: LightGallerySettings) {
    document.querySelectorAll(selector).forEach(function(element) {
        if(options) {
            options.plugins = [Thumbnail, Autoplay, Share];
        }

        let lightgallery = new LightGallery(element as HTMLElement, options);
    });
}

